import { render, staticRenderFns } from "./startimpression.vue?vue&type=template&id=14bcc138&scoped=true&lang=html&"
import script from "./startimpression.vue?vue&type=script&lang=js&"
export * from "./startimpression.vue?vue&type=script&lang=js&"
import style0 from "./startimpression.vue?vue&type=style&index=0&id=14bcc138&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bcc138",
  null
  
)

export default component.exports